import { isAuthenticatedCustomer } from '@ori/auth';
import { useToken } from '@ori/favorites-hooks';
import {
  updateCustomerProductListTypeProductList,
  useApiClient,
} from '@ori/global-api-client-react';
import { useCallback, useMemo, useState } from 'react';

import { createFavoriteProductsList, getFavoriteProductsList } from '../api';
import { mapCurrent, mapToggle, mapUpdate } from '../utils';

export const useFavorites = () => {
  const [favorites, setFavorites] = useState<string[]>([]);
  const [id, setId] = useState<string>();
  const client = useApiClient();
  const { customerId } = useToken();
  const fetchOrCreate = useCallback(async () => {
    if (isAuthenticatedCustomer(customerId)) {
      const fetched = await getFavoriteProductsList({ client, customerId });
      if (fetched === undefined) {
        return createFavoriteProductsList({ client, customerId });
      }

      return fetched;
    }

    return { items: [], productListId: undefined };
  }, [client, customerId]);
  const request = useCallback(async () => {
    const { items, productListId } = await fetchOrCreate();
    const current = mapCurrent(items);
    setFavorites(current);
    setId(productListId);

    return { favorites: current, id: productListId };
  }, [fetchOrCreate]);
  const toggle = useCallback(
    async (productCode: string) => {
      if (id) {
        const current = mapToggle(productCode, favorites);
        await updateCustomerProductListTypeProductList(client, customerId, 'Favorite', id, {
          items: mapUpdate(current),
          productListId: id,
        });
        setFavorites(current);

        return { favorites: current, id };
      }

      return { favorites, id };
    },
    [client, customerId, favorites, id],
  );

  return useMemo(
    () => ({
      id,
      favorites,
      request,
      toggle,
    }),
    [id, favorites, request, toggle],
  );
};
